import {
  Button,
  CircularProgress,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material'
import { FC } from 'react'
import { Link } from 'react-router-dom'
import { Header } from 'src/components/header/Header'
import { HeaderTitle } from 'src/components/header/HeaderTitle'
import { gray } from 'src/features/muikds/kdsColors'
import { useQueryMasterTemplates } from '../../api/useQueryMasterTemplates'

type Props = {
  open: boolean
  onClose: () => void
  masterUuid: string
  masterName: string
}

export const MasterTemplatesDrawer: FC<Props> = ({
  open,
  onClose,
  masterUuid,
  masterName,
}) => {
  const { data, isLoading, isError } = useQueryMasterTemplates(masterUuid, open)
  const templates = data?.templates ?? []

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDrawer-paper': {
          width: 600,
          display: 'grid',
          gridTemplateAreas: `
            "header"
            "content"
            "footer"
          `,
          gridTemplateRows: 'auto 1fr auto',
        },
      }}
    >
      <Header
        style={{ gridArea: 'header' }}
        css={{ height: 'auto', minHeight: 72 }}
      >
        <HeaderTitle
          title={`${masterName} に紐づいているひな形`}
          titleSx={{ whiteSpace: 'normal', wordBreak: 'break-all' }}
        />
      </Header>

      <Stack sx={{ gridArea: 'content', overflowY: 'auto' }}>
        {isLoading ? (
          <Stack alignItems="center" justifyContent="center" sx={{ flex: 1 }}>
            <CircularProgress />
          </Stack>
        ) : isError ? (
          <Stack alignItems="center" justifyContent="center" sx={{ flex: 1 }}>
            <Typography color="error">
              ひな形一覧の取得に失敗しました
            </Typography>
          </Stack>
        ) : templates.length === 0 ? (
          <Stack alignItems="center" justifyContent="center" sx={{ flex: 1 }}>
            <Typography color="text.secondary">
              紐づいているひな形がありません
            </Typography>
          </Stack>
        ) : (
          <List>
            {templates.map(template => (
              <ListItem key={template.id} disablePadding>
                <ListItemButton
                  component={Link}
                  to={`/templates/${template.id}/pages/edit`}
                  target="_blank"
                >
                  <ListItemText
                    primary={template.name}
                    sx={{ wordBreak: 'break-all' }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        )}
      </Stack>

      <Stack
        direction="row"
        justifyContent="flex-end"
        sx={{
          gridArea: 'footer',
          px: 3,
          py: 2,
          borderTop: 1,
          borderColor: 'divider',
          backgroundColor: gray[2],
        }}
      >
        <Button variant="contained" color="secondary" onClick={onClose}>
          閉じる
        </Button>
      </Stack>
    </Drawer>
  )
}
